module.exports = __webpack_public_path__ + "static/img/quan_7.7d6ef1db.png";